import { createColumnHelper } from '@tanstack/react-table';

import { Pickup } from 'types/pickup';
import { Status } from 'types/items';
import { convertUTCToLocal } from 'utils/dateUtils';

const col = createColumnHelper<Pickup>();

/** Pickups relabel two statuses: OPEN shows as SCHEDULED, CLOSE as DONE. */
const renderStatus = (_status?: number) => {
  if (_status === undefined) {
    return '-';
  }

  let status = Status[_status];

  if (_status === Status.OPEN) {
    status = 'SCHEDULED';
  }

  if (_status === Status.CLOSE) {
    status = 'DONE';
  }

  return status;
};

export const buildPickupColumns = () => [
  col.accessor('pickupNumber', {
    header: 'Pickup No',
    minSize: 70,
    cell: (info) => info.getValue() || '-',
  }),
  col.accessor((pickup) => convertUTCToLocal(pickup?.date, true, true), {
    id: 'date',
    header: 'Pickup Date',
    minSize: 150,
    meta: { sortField: 'date' },
  }),
  col.accessor(
    (pickup) =>
      typeof pickup?.collectionPoint === 'string'
        ? pickup?.collectionPoint
        : pickup?.collectionPoint?.name || '-',
    {
      id: 'collectionPoint',
      header: 'Collection Point',
      minSize: 150,
      meta: { sortField: 'collectionPoint.name' },
    },
  ),
  col.accessor((pickup) => pickup?.eventName || '-', {
    id: 'eventName',
    header: 'Event Name',
    minSize: 130,
  }),
  col.accessor(
    (pickup) =>
      pickup?.pickedUpStats?.reduce((acc, i) => acc + i.quantity, 0) || '-',
    {
      id: 'itemCount',
      header: 'Item Count',
      minSize: 90,
      meta: { align: 'center' },
    },
  ),
  col.accessor((pickup) => renderStatus(pickup?.status), {
    id: 'status',
    header: 'Status',
    minSize: 100,
    meta: { align: 'center' },
  }),
  col.accessor((pickup) => pickup?.notes || ' - ', {
    id: 'notes',
    header: 'Notes',
    minSize: 150,
    size: 320,
    meta: { align: 'center' },
  }),
  col.accessor((pickup) => (pickup?.isFinalPickup ? 'Yes' : 'No'), {
    id: 'isFinalPickup',
    header: 'Final Pickup',
    minSize: 90,
    meta: { align: 'center' },
  }),
];
